// Third-party scripts (Google sign-in, VideoAsk, etc.) inject iframes without
// a title attribute, which screen readers need to identify frames
// (WCAG 4.1.2). We can't change those scripts, so give any untitled iframe a
// title describing where its content comes from.

const KNOWN_FRAMES = [
  [/accounts\.google\.com|apis\.google\.com/, 'Google sign-in'],
  [/login\.microsoftonline\.com|login\.live\.com/, 'Microsoft sign-in'],
  [/videoask\.com/, 'Welcome tour video'],
];

function describe(iframe) {
  const src = iframe.getAttribute('src') || '';
  const known = KNOWN_FRAMES.find(([pattern]) => pattern.test(src));
  if (known) return known[1];
  try {
    return `Embedded content from ${
      new URL(src, window.location.href).hostname
    }`;
  } catch (e) {
    return 'Embedded content';
  }
}

function titleFrame(iframe) {
  if (!iframe.getAttribute('title')) {
    iframe.setAttribute('title', describe(iframe));
  }
}

export function titleUntitledIframes(root = document.body) {
  if (!root || typeof MutationObserver === 'undefined') return undefined;

  root.querySelectorAll('iframe').forEach(titleFrame);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        if (mutation.target.tagName === 'IFRAME') titleFrame(mutation.target);
        return;
      }
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'IFRAME') titleFrame(node);
        else node.querySelectorAll('iframe').forEach(titleFrame);
      });
    });
  });
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['src', 'title'],
  });
  return observer;
}
